import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    MenuItem,
    Select,
    TextField,
} from '@material-ui/core';
import { useEffect } from 'react';
import { useState, useReducer } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { LoadProfileRoutes } from '.';
import { ActionHeader } from '..';
import en from '../../../../lang/en-us';
import { CustomRadio } from '../../../../lib/CustomRadio';
import TextInput from '../../../../lib/TextField';
import { getCountries } from '../../../../redux-store/actions/link';
import { sendPhoneOTP, getFatcaDetails } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { UPDATE_PURCHASE_INFO } from '../../../../redux-store/types/newPurchase';
import { IsAllow } from '../../../../redux-store/types/portfolio';
import { checkForOnlyAlphabets, isAlphaNumeric, isNumber } from '../../../../utils/constants';
import { KYC_MIN_LENGHTHS, MAX_LENGTHS } from '../../makeNct/FatcaDeclaration/utils';
import { getCountryNameFromCode } from './FatcaDetailsPurchase';
const { dashboard, dbCommercial } = en;

export type COUNTRY_DETAILS = {
    code: string;
    dial_code: string;
    name: string;
};

type COUNTRIES = {
    countries: COUNTRY_DETAILS[];
};

export enum EDIT_ACTION {
    EDIT = 'EDIT',
    SAVE = 'SAVE',
}

const initialState = {
    isIndianResident: '',
    tinAvailability: false,
    identityVerification: '',
    reasonOption: '',
    countryOfBirth: '',
    nationality: '',
    taxResidency: '',
    identityVerificationText: '',
    tinId: '',
    declaration: '',
    reasonOptionText: '',
    remarks: '',
};

export const taxReducer = (state: any, action: any) => {
    switch (action.type) {
        case 'INITIALIZE':
            return [...action.payload];
        case 'CHANGE':
            const newState = [
                ...state.slice(0, action.payload.index),
                {
                    ...state[action.payload.index],
                    [action.payload.key]: action.payload.value,
                },
                ...state.slice(action.payload.index + 1),
            ];
            return newState;
        case 'ADD':
            return [...state, ...taxInitialState];
        case 'DELETE':
            return [
                ...state.slice(0, action.payload.index),
                ...state.slice(action.payload.index + 1),
            ];
        default:
            return state;
    }
};

const taxInitialState = [
    {
        taxResidency: '',
        tinId: '',
        identityVerification: '',
        identityVerificationText: '',
        tinAvailability: false,
        reasonOption: '',
        reasonOptionText: '',
        editing: true,
        errPresent: false,
        errors: {},
    },
];

function FatcaDeclaration(props: any) {
    const { fatcaDetails, occupation } = props.purchaseDetails;
    const data = fatcaDetails.find((fatca: any) => fatca.fatcaId === 'FH') || {};
    const [state, setState] = useState<any>({ ...initialState, declaration: data.declaration });
    const [isChecked, setChecked] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [taxData, taxDispatch] = useReducer(taxReducer, taxInitialState);

    const [errors, setErrors] = useState<any>({});
    const [countries, setCountries] = useState<COUNTRY_DETAILS[]>([]);
    const dispatch = useDispatch();
    const history = useHistory();

    const getTinReasonOption = (value: string) => {
        switch ((value || '').trim().toLowerCase()) {
            case 'A'.toLowerCase():
            case dashboard.FatcaDeclaration.accountHolderLiable.trim().toLowerCase():
                return 'A';
            case 'B'.toLowerCase():
            case dashboard.FatcaDeclaration.noTinRequired.trim().toLowerCase():
                return 'B';
            default:
                return 'C';
        }
    };

    useEffect(() => {
        async function callApi() {
            try {
                setLoading(true);
                const { body } = await props.getCountries(); // Use Reducer state;
                const { countries: masterData = [] }: COUNTRIES = body;
                setCountries(masterData);
                setState({
                    ...state,
                    isIndianResident: data?.taxResidencyOtherthanIndia || data?.declaration,
                    countryOfBirth:
                        (data?.taxResidencyOtherthanIndia || data?.declaration) === IsAllow.No
                            ? 'India'
                            : data?.countryOfBirth,
                    placeOfBirth: data?.placeOfBirth,
                    nationality: data?.nationality,
                });
                const taxDetails = data?.taxResidency || [];
                const _taxDetails = taxDetails.map((taxDetail: any) => ({
                    taxResidency: taxDetail.country,
                    tinId: taxDetail.taxId,
                    identityVerification:
                        taxDetail.idType?.toLowerCase() === 'tin' ? 'tin' : 'other-identity',
                    identityVerificationText:
                        taxDetail.idType?.toLowerCase() === 'tin' ? '' : taxDetail.idType,
                    tinAvailability: !taxDetail.taxId,
                    reasonOption: !!taxDetail.tinReason
                        ? getTinReasonOption(taxDetail.tinReason)
                        : getTinReasonOption(taxDetail.remarks),
                    reasonOptionText: !!taxDetail.tinReason
                        ? getTinReasonOption(taxDetail.tinReason)
                        : getTinReasonOption(taxDetail.remarks) === 'C'
                            ? taxDetail.remarks
                            : '',
                    editing: false,
                    errPresent: false,
                    errors: {},
                }));
                taxDispatch({
                    type: 'INITIALIZE',
                    payload: _taxDetails,
                });
                setLoading(false);
            } catch (err: any) {
                setLoading(false);
                alert(err.message);
            }
        }
        callApi();
        return () => {
            setCountries([]);
        };
    }, []);

    const checkMaxCharacter = (value: string) => {
        return value.length <= 10 ? true : false;
    };

    const validateTaxDetail = (taxDetail: any, index: number) => {
        let errors: any = {};
        let formIsValid = true;
        if (!state.isIndianResident) {
            formIsValid = false;
            errors['isIndianResident'] = dashboard.FatcaDeclaration.errors.taxResidency;
        }
        if (state.isIndianResident === 'Y') {
            if (!taxDetail.taxResidency || taxDetail.taxResidency === '0') {
                formIsValid = false;
                errors['taxResidency'] = dashboard.FatcaDeclaration.errors.countryOfTaxResidency;
            }
            if (!taxDetail.tinAvailability) {
                if (!taxDetail.tinId) {
                    formIsValid = false;
                    errors['tinId'] = dashboard.FatcaDeclaration.errors.tinNumber;
                }
                if (!taxDetail.identityVerification) {
                    formIsValid = false;
                    errors['identityVerification'] =
                        dashboard.FatcaDeclaration.errors.identificationType;
                }
                if (
                    taxDetail.identityVerification === 'other-identity' &&
                    !taxDetail.identityVerificationText
                ) {
                    formIsValid = false;
                    errors['identityVerificationText'] =
                        dashboard.FatcaDeclaration.errors.identificationReason;
                }
            } else {
                if (!taxDetail.reasonOption) {
                    formIsValid = false;
                    errors['reasonOption'] = dashboard.FatcaDeclaration.errors.noTinReason;
                }
                if (taxDetail.reasonOption === 'C' && !taxDetail.reasonOptionText) {
                    formIsValid = false;
                    errors['reasonOptionText'] = dashboard.FatcaDeclaration.errors.noTinReason;
                }
                if (!checkMaxCharacter(state.reasonOptionText)) {
                    formIsValid = false;
                    errors['reasonOptionText'] =
                        dashboard.FatcaDeclaration.errors.maxCharacterForTinReason;
                }
            }
        }
        if (!formIsValid) {
            taxDispatch({
                type: 'CHANGE',
                payload: { index: index, value: true, key: 'errPresent' },
            });
        }
        taxDispatch({
            type: 'CHANGE',
            payload: { index: index, value: errors, key: 'errors' },
        });
        return formIsValid;
    };

    const validateCommonFields = (state: any, isChecked: any) => {
        let errors: any = {};
        let formIsValid = true;
        if (!isChecked) {
            formIsValid = false;
            errors['isChecked'] = dashboard.FatcaDeclaration.errors.declarationBox;
        }
        if (!state.countryOfBirth || state.countryOfBirth === '0') {
            formIsValid = false;
            errors['countryOfBirth'] = dashboard.FatcaDeclaration.errors.countryOfBirth;
        }
        if (!state.nationality || state.nationality === '0') {
            formIsValid = false;
            errors['nationality'] = dashboard.FatcaDeclaration.errors.nationality;
        }
        if (!state.placeOfBirth) {
            formIsValid = false;
            errors['placeOfBirth'] = dashboard.FatcaDeclaration.errors.placeOfBirth;
        } else if (state.placeOfBirth?.length < KYC_MIN_LENGHTHS.placeOfBirth) {
            formIsValid = false;
            errors['placeOfBirth'] = dashboard.FatcaDeclaration.errors.pobMinLength;
        }
        setErrors(errors);
        return formIsValid;
    };

    const validatePlaceOfBirth = (state: any) => {
        let errors: any = {};
        let formIsValid = true;
        if (!state.placeOfBirth) {
            formIsValid = false;
            errors['placeOfBirth'] = dashboard.FatcaDeclaration.errors.placeOfBirth;
        } else if (state.placeOfBirth?.length < KYC_MIN_LENGHTHS.placeOfBirth) {
            formIsValid = false;
            errors['placeOfBirth'] = dashboard.FatcaDeclaration.errors.pobMinLength;
        }
        setErrors(errors);
        return formIsValid;
    };

    const handleSubmit = async () => {
        const { countryBirth, ...rest } = data;
        if (state.isIndianResident === IsAllow.No && isChecked && validatePlaceOfBirth(state)) {
            dispatch({
                type: UPDATE_PURCHASE_INFO,
                body: {
                    fatcaDetails: [
                        {
                            ...rest,
                            occupation,
                            declaration: IsAllow.No,
                            taxResidency: [
                                {
                                    country: '',
                                    idType: '',
                                    taxId: '',
                                    tinReason: '',
                                    tinRemarks: '',
                                },
                            ],
                            taxResidencyOtherthanIndia: IsAllow.No,
                            placeOfBirth: state.placeOfBirth,
                            countryOfBirth: 'India',
                        },
                    ],
                },
            });
            history.goBack();
            return;
        }
        let taxDetailsValid = true;
        const commonFieldsValid = validateCommonFields(state, isChecked);
        taxData.forEach(
            (taxDetail: any, index: number) =>
                (taxDetailsValid = taxDetailsValid && validateTaxDetail(taxDetail, index)),
        );
        if (taxDetailsValid && commonFieldsValid) {
            const reformattedTaxDetailsData = taxData.map((taxDetail: any, index: number) => ({
                country: taxDetail.taxResidency,
                id: index + 1,
                idType:
                    taxDetail.identityVerification === 'tin'
                        ? 'TIN'
                        : taxDetail.identityVerificationText || '',
                taxId: taxDetail.tinId || '',
                tinReason: !!taxDetail.reasonOption ? taxDetail.reasonOption : '',
                tinRemarks: taxDetail.reasonOption === 'C' ? taxDetail.reasonOptionText : '',
            }));

            let formattedFatcaData = {
                ...fatcaDetails[0],
                occupation,
                countryOfBirth: state.countryOfBirth,
                nationality: state.nationality,
                isIndianResident: state.isIndianResident,
                taxResidency: reformattedTaxDetailsData,
                placeOfBirth: state.placeOfBirth,
                declaration: IsAllow.YES,
                taxResidencyOtherthanIndia: state.isIndianResident,
            };
            dispatch({
                type: UPDATE_PURCHASE_INFO,
                body: { fatcaDetails: [formattedFatcaData] },
            });
            history.goBack();
        }
    };
    const handleAdd = () => taxDispatch({ type: 'ADD' });
    const handleDelete = (index: number) => taxDispatch({ type: 'DELETE', payload: { index } });
    const handleEdit = (index: number, action: EDIT_ACTION) => {
        let dispatchValue = action === EDIT_ACTION.EDIT ? true : false;
        if (action === EDIT_ACTION.SAVE && !validateTaxDetail(taxData[index], index)) {
            return;
        }
        taxDispatch({
            type: 'CHANGE',
            payload: { index, value: dispatchValue, key: 'editing' },
        });
        if (action == EDIT_ACTION.SAVE) {
            taxDispatch({
                type: 'CHANGE',
                payload: { index, value: false, key: 'errPresent' },
            });
        }
    };
    return (
        <div className="curved-bg fatca-edit">
            <ActionHeader header={dbCommercial.newPurchase.rightMenu.fatcaEdit.heading} />
            <div className="curved-bg-content">
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top fatca-top-content-outer">
                        <div className="fatca-top-content" style={{ borderBottom: 0 }}>
                            <div className="tax-resident">
                                <CustomRadio
                                    extraClass="fatca-tax-resident"
                                    title={dashboard.FatcaDeclaration.taxResident}
                                    name="tax-resident"
                                    list={[
                                        {
                                            label: dashboard.FatcaDeclaration.yesTxt,
                                            value: IsAllow.YES,
                                        },
                                        {
                                            label: dashboard.FatcaDeclaration.noTxt,
                                            value: IsAllow.No,
                                        },
                                    ]}
                                    selectedValue={state.isIndianResident}
                                    handleRadioChange={(value: string) => {
                                        const { isIndianResident, ...rest } = errors;
                                        setErrors(rest);
                                        setState((prev: any) => ({
                                            ...initialState,
                                            placeOfBirth: prev.placeOfBirth,
                                            isIndianResident: value,
                                        }));
                                        if (value === IsAllow.No) {
                                            setState((prev: any) => ({
                                                ...prev,
                                                countryOfBirth: 'India',
                                            }));
                                        }
                                    }}
                                    error={!!errors.isIndianResident}
                                    helperText={errors.isIndianResident}
                                    isLoading={loading}
                                />
                            </div>
                            <Grid container spacing={1} className="taxResident-birthplace">
                                {(state.isIndianResident === IsAllow.YES ||
                                    state.isIndianResident === IsAllow.No) && (
                                        <Grid item xs={12} sm={4}>
                                            <div className="fatca-enter-pan">
                                                <FormControl
                                                    variant="outlined"
                                                    error={!!errors.countryOfBirth}
                                                >
                                                    <Select
                                                        labelId="countryOfBirth"
                                                        id="countryOfBirth"
                                                        value={state.countryOfBirth || '0'}
                                                        onChange={({ target: { value } }) => {
                                                            setState((prevState: any) => {
                                                                return {
                                                                    ...prevState,
                                                                    countryOfBirth: value,
                                                                };
                                                            });
                                                        }}
                                                        disabled={state.isIndianResident === IsAllow.No}
                                                        onFocus={() => {
                                                            const { countryOfBirth, ...rest } = errors;
                                                            setErrors(rest);
                                                        }}
                                                    >
                                                        {state.isIndianResident === IsAllow.YES && (
                                                            <MenuItem value="0">
                                                                {' '}
                                                                Country of Birth
                                                            </MenuItem>
                                                        )}
                                                        {state.isIndianResident === IsAllow.No ? (
                                                            <MenuItem value="India"> India </MenuItem>
                                                        ) : (
                                                            countries.map((_ele: COUNTRY_DETAILS) => (
                                                                <MenuItem value={_ele.name}>
                                                                    {_ele.name}
                                                                </MenuItem>
                                                            ))
                                                        )}
                                                    </Select>
                                                    <FormHelperText className={'error'}>
                                                        {errors.countryOfBirth}
                                                    </FormHelperText>
                                                </FormControl>
                                            </div>
                                        </Grid>
                                    )}
                                {state.isIndianResident === IsAllow.YES && (
                                    <Grid item xs={12} sm={4}>
                                        <div className="fatca-nationality">
                                            <FormControl
                                                variant="outlined"
                                                error={!!errors.nationality}
                                            >
                                                <Select
                                                    labelId="nationality"
                                                    id="nationality"
                                                    value={state.nationality || '0'}
                                                    onChange={({ target: { value } }) =>
                                                        setState({
                                                            ...state,
                                                            nationality: value,
                                                        })
                                                    }
                                                    onFocus={() => {
                                                        const { nationality, ...rest } = errors;
                                                        setErrors(rest);
                                                    }}
                                                >
                                                    <MenuItem value="0">
                                                        {dashboard.FatcaDeclaration.nationality}
                                                    </MenuItem>
                                                    {countries.map((_ele: COUNTRY_DETAILS) => (
                                                        <MenuItem value={_ele.name}>
                                                            {_ele.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText className={'error'}>
                                                    {errors.nationality}
                                                </FormHelperText>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                )}
                                {(state.isIndianResident === IsAllow.No ||
                                    state.isIndianResident === IsAllow.YES) && (
                                        <Grid item xs={12} sm={5}>
                                            <TextField
                                                id="birth-place"
                                                name="placeOfBirth"
                                                variant="outlined"
                                                helperText={
                                                    !!errors.placeOfBirth ? errors.placeOfBirth : ''
                                                }
                                                error={!!errors.placeOfBirth}
                                                value={state.placeOfBirth}
                                                onChange={(e) => {
                                                    if (
                                                        checkForOnlyAlphabets(e.target.value) &&
                                                        e.target.value.length <=
                                                        MAX_LENGTHS.placeOfBirth
                                                    ) {
                                                        setState((prev: any) => ({
                                                            ...prev,
                                                            placeOfBirth: e.target.value,
                                                        }));
                                                        const { placeOfBirth, ...rest } = errors;
                                                        setErrors(rest);
                                                    }
                                                }}
                                                label={
                                                    dashboard.FatcaDeclaration.kycFields.placeOfBirth
                                                }
                                            />
                                        </Grid>
                                    )}
                            </Grid>
                        </div>
                        {state.isIndianResident === IsAllow.YES &&
                            taxData.map((taxDetail: any, index: number) => {
                                if (!taxDetail.editing) {
                                    return (
                                        <div
                                            className="fatca-edit-box"
                                            style={{
                                                borderColor: taxDetail.errPresent ? 'red' : 'white',
                                                borderRadius: '2px',
                                                borderStyle: 'solid',
                                            }}
                                        >
                                            <h4>ID - {index + 1}</h4>
                                            <div className="fatca-edit-box-info">
                                                <p>
                                                    {
                                                        dbCommercial.newPurchase.rightMenu.fatcaEdit
                                                            .countryOfTaxResidency
                                                    }
                                                    <span>
                                                        {getCountryNameFromCode(
                                                            countries,
                                                            taxDetail.taxResidency,
                                                        )}
                                                    </span>
                                                </p>
                                                <p>
                                                    {
                                                        dbCommercial.newPurchase.rightMenu.fatcaEdit
                                                            .taxId
                                                    }
                                                    <span>
                                                        {' '}
                                                        {taxDetail.tinAvailability
                                                            ? 'NA'
                                                            : taxDetail.tinId}
                                                    </span>
                                                </p>
                                                <p>
                                                    {
                                                        dbCommercial.newPurchase.rightMenu.fatcaEdit
                                                            .type
                                                    }
                                                    <span>
                                                        {' '}
                                                        {taxDetail.tinAvailability
                                                            ? 'Unavailable'
                                                            : taxDetail.identityVerification}
                                                    </span>
                                                </p>
                                            </div>
                                            <a
                                                className="edit-icon save-icon"
                                                onClick={() => handleEdit(index, EDIT_ACTION.EDIT)}
                                            >
                                                <img
                                                    src="/images/edit-fill-purple.svg"
                                                    alt="edit icon"
                                                />
                                            </a>
                                            {taxData.length > 1 && (
                                                <a
                                                    className="edit-icon"
                                                    onClick={() => handleDelete(index)}
                                                >
                                                    <img
                                                        src="/images/delete-folio.svg"
                                                        alt="delete icon"
                                                    />
                                                </a>
                                            )}
                                        </div>
                                    );
                                }
                                return (
                                    <div className="curved-bg-content-inner-top fatca-middle-content">
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} sm={5}>
                                                <div className="fatca-enter-pan">
                                                    <FormControl
                                                        variant="outlined"
                                                        error={!!taxDetail.errors.taxResidency}
                                                    >
                                                        <Select
                                                            labelId="taxResidencyCountry"
                                                            id="taxResidencyCountry"
                                                            value={taxDetail.taxResidency || '0'}
                                                            onChange={({ target: { value } }) => {
                                                                taxDispatch({
                                                                    type: 'CHANGE',
                                                                    payload: {
                                                                        index,
                                                                        value,
                                                                        key: 'taxResidency',
                                                                    },
                                                                });
                                                            }}
                                                            onFocus={() => {
                                                                const { taxResidency, ...rest } =
                                                                    taxDetail.errors;
                                                                taxDispatch({
                                                                    type: 'CHANGE',
                                                                    payload: {
                                                                        index: index,
                                                                        key: 'errors',
                                                                        value: rest,
                                                                    },
                                                                });
                                                            }}
                                                        >
                                                            <MenuItem value="0">
                                                                {
                                                                    dashboard.FatcaDeclaration
                                                                        .taxResidencyCountry
                                                                }
                                                            </MenuItem>
                                                            {countries.map(
                                                                (_ele: COUNTRY_DETAILS) => (
                                                                    <MenuItem value={_ele.code}>
                                                                        {_ele.name}
                                                                    </MenuItem>
                                                                ),
                                                            )}
                                                        </Select>
                                                        <FormHelperText className={'error'}>
                                                            {taxDetail.errors.taxResidency}
                                                        </FormHelperText>
                                                    </FormControl>
                                                </div>
                                            </Grid>
                                            <Grid item xs={12} sm={7} lg={5}>
                                                <div className="fatca-enter-tin">
                                                    <TextInput
                                                        label={dashboard.FatcaDeclaration.tinNo}
                                                        variant="outlined"
                                                        disabled={taxDetail.tinAvailability}
                                                        onChange={({ target: { value } }) => {
                                                            isAlphaNumeric(value) && value.length <= 50
                                                                ? taxDispatch({
                                                                    type: 'CHANGE',
                                                                    payload: {
                                                                        index,
                                                                        value,
                                                                        key: 'tinId',
                                                                    },
                                                                })
                                                                : null;
                                                        }}
                                                        onFocus={() => {
                                                            const { tinId, ...rest } =
                                                                taxDetail.errors;
                                                            taxDispatch({
                                                                type: 'CHANGE',
                                                                payload: {
                                                                    index: index,
                                                                    key: 'errors',
                                                                    value: rest,
                                                                },
                                                            });
                                                        }}
                                                        value={taxDetail.tinId}
                                                        error={!!taxDetail.errors.tinId}
                                                        helperText={taxDetail.errors.tinId}
                                                    />
                                                    <div className="fatca-tin-nonavail">
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    name="fatca-not-available"
                                                                    checked={
                                                                        taxDetail.tinAvailability
                                                                    }
                                                                    onChange={(e) => {
                                                                        if (
                                                                            Object.keys(
                                                                                taxDetail.errors,
                                                                            ).includes('tinId')
                                                                        ) {
                                                                            const {
                                                                                tinId,
                                                                                ...rest
                                                                            } = taxDetail.errors;
                                                                            taxDispatch({
                                                                                type: 'CHANGE',
                                                                                payload: {
                                                                                    index: index,
                                                                                    key: 'errors',
                                                                                    value: rest,
                                                                                },
                                                                            });
                                                                        }
                                                                        if (e.target.checked) {
                                                                            taxDispatch({
                                                                                type: 'CHANGE',
                                                                                payload: {
                                                                                    index,
                                                                                    value: '',
                                                                                    key: 'tinId',
                                                                                },
                                                                            });
                                                                            taxDispatch({
                                                                                type: 'CHANGE',
                                                                                payload: {
                                                                                    index,
                                                                                    value: '',
                                                                                    key: 'identityVerificationText',
                                                                                },
                                                                            });
                                                                        }
                                                                        if (!e.target.checked) {
                                                                            taxDispatch({
                                                                                type: 'CHANGE',
                                                                                payload: {
                                                                                    index,
                                                                                    value: '',
                                                                                    key: 'reasonOption',
                                                                                },
                                                                            });
                                                                            taxDispatch({
                                                                                type: 'CHANGE',
                                                                                payload: {
                                                                                    index,
                                                                                    value: '',
                                                                                    key: 'reasonOptionText',
                                                                                },
                                                                            });
                                                                        }
                                                                        taxDispatch({
                                                                            type: 'CHANGE',
                                                                            payload: {
                                                                                index,
                                                                                value: !taxDetail.tinAvailability,
                                                                                key: 'tinAvailability',
                                                                            },
                                                                        });
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                dashboard.FatcaDeclaration
                                                                    .tinNotAvailable
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </Grid>
                                            {!taxDetail.tinAvailability && (
                                                <>
                                                    <Grid item xs={12} className="fatca-id-type">
                                                        <CustomRadio
                                                            extraClass="fatca-identification-type"
                                                            title={
                                                                dashboard.FatcaDeclaration
                                                                    .identificationType
                                                            }
                                                            name="identification-type"
                                                            list={[
                                                                {
                                                                    label: dashboard
                                                                        .FatcaDeclaration.tinTxt,
                                                                    value: 'tin',
                                                                },
                                                                {
                                                                    label: dashboard
                                                                        .FatcaDeclaration.othersTxt,
                                                                    value: 'other-identity',
                                                                },
                                                            ]}
                                                            selectedValue={
                                                                taxDetail.identityVerification
                                                            }
                                                            handleRadioChange={(value: string) => {
                                                                taxDispatch({
                                                                    type: 'CHANGE',
                                                                    payload: {
                                                                        index,
                                                                        value,
                                                                        key: 'identityVerification',
                                                                    },
                                                                });
                                                            }}
                                                            error={
                                                                !!taxDetail.errors
                                                                    .identityVerification
                                                            }
                                                            helperText={
                                                                taxDetail.errors
                                                                    .identityVerification
                                                            }
                                                        />
                                                        {taxDetail.identityVerification ===
                                                            'other-identity' && (
                                                                <div className="fatca-enter-tin">
                                                                    <TextInput
                                                                        label={
                                                                            dashboard.FatcaDeclaration
                                                                                .typeHere
                                                                        }
                                                                        variant="outlined"
                                                                        value={
                                                                            taxDetail.identityVerificationText
                                                                        }
                                                                        onChange={({
                                                                            target: { value },
                                                                        }) => {
                                                                            if (
                                                                                checkForOnlyAlphabets(
                                                                                    value,
                                                                                ) &&
                                                                                value.length <=
                                                                                MAX_LENGTHS.otherIdentity
                                                                            ) {
                                                                                taxDispatch({
                                                                                    type: 'CHANGE',
                                                                                    payload: {
                                                                                        index: index,
                                                                                        key: 'identityVerificationText',
                                                                                        value,
                                                                                    },
                                                                                });
                                                                            }
                                                                        }}
                                                                        onFocus={() => {
                                                                            const {
                                                                                identityVerificationText,
                                                                                ...rest
                                                                            } = taxDetail.errors;
                                                                            taxDispatch({
                                                                                type: 'CHANGE',
                                                                                payload: {
                                                                                    index: index,
                                                                                    value: rest,
                                                                                    key: 'errors',
                                                                                },
                                                                            });
                                                                        }}
                                                                        error={
                                                                            !!taxDetail.errors
                                                                                .identityVerificationText
                                                                        }
                                                                        helperText={
                                                                            taxDetail.errors
                                                                                .identityVerificationText
                                                                        }
                                                                    />
                                                                </div>
                                                            )}
                                                    </Grid>
                                                </>
                                            )}
                                            {taxDetail.tinAvailability && (
                                                <Grid item xs={12}>
                                                    <CustomRadio
                                                        extraClass="fatca-select-reason"
                                                        title={
                                                            dashboard.FatcaDeclaration.selectReason
                                                        }
                                                        name="fatca-select-reason"
                                                        list={[
                                                            {
                                                                label: dashboard.FatcaDeclaration
                                                                    .accountHolderLiable,
                                                                value: 'A',
                                                            },
                                                            {
                                                                label: dashboard.FatcaDeclaration
                                                                    .noTinRequired,
                                                                value: 'B',
                                                            },
                                                            {
                                                                label: dashboard.FatcaDeclaration
                                                                    .othersSpecify,
                                                                value: 'C',
                                                            },
                                                        ]}
                                                        handleRadioChange={(value: string) => {
                                                            const { reasonOption, ...rest } =
                                                                taxDetail.errors;
                                                            taxDispatch({
                                                                type: 'CHANGE',
                                                                payload: {
                                                                    index: index,
                                                                    key: 'errors',
                                                                    value: rest,
                                                                },
                                                            });
                                                            taxDispatch({
                                                                type: 'CHANGE',
                                                                payload: {
                                                                    index,
                                                                    value,
                                                                    key: 'reasonOption',
                                                                },
                                                            });
                                                        }}
                                                        selectedValue={taxDetail.reasonOption}
                                                        error={!!taxDetail.errors.reasonOption}
                                                        helperText={taxDetail.errors.reasonOption}
                                                    />
                                                    {taxDetail.reasonOption === 'C' && (
                                                        <TextInput
                                                            className="fatca-others-reason"
                                                            label={
                                                                dashboard.FatcaDeclaration.typeHere
                                                            }
                                                            variant="outlined"
                                                            multiline
                                                            rows={4}
                                                            onChange={({ target: { value } }) => {
                                                                taxDispatch({
                                                                    type: 'CHANGE',
                                                                    payload: {
                                                                        index,
                                                                        value,
                                                                        key: 'reasonOptionText',
                                                                    },
                                                                });
                                                            }}
                                                            onFocus={() => {
                                                                const {
                                                                    reasonOptionText,
                                                                    ...rest
                                                                } = taxDetail.errors;
                                                                taxDispatch({
                                                                    type: 'CHANGE',
                                                                    payload: {
                                                                        index: index,
                                                                        key: 'errors',
                                                                        value: rest,
                                                                    },
                                                                });
                                                            }}
                                                            value={taxDetail.reasonOptionText}
                                                            error={
                                                                !!taxDetail.errors.reasonOptionText
                                                            }
                                                            helperText={
                                                                taxDetail.errors.reasonOptionText
                                                            }
                                                        />
                                                    )}
                                                </Grid>
                                            )}
                                            <div className="btns">
                                                {taxData.length > 1 && (
                                                    <Button
                                                        className="customBtn cancelBtn"
                                                        onClick={() => handleDelete(index)}
                                                    >
                                                        Delete
                                                    </Button>
                                                )}

                                                <Button
                                                    className="customBtn"
                                                    onClick={() =>
                                                        handleEdit(index, EDIT_ACTION.SAVE)
                                                    }
                                                >
                                                    Save
                                                </Button>
                                            </div>
                                        </Grid>
                                    </div>
                                );
                            })}
                        {taxData.length < 3 && state.isIndianResident === IsAllow.YES && (
                            <div className="add-tax">
                                <p>{`You can add ${3 - taxData.length} more ID${taxData.length == 2 ? '' : "'S"
                                    }`}</p>
                                <a onClick={handleAdd}>
                                    {dbCommercial.newPurchase.rightMenu.fatcaEdit.addId}
                                </a>
                            </div>
                        )}
                    </div>
                    <div className="curved-bg-content-inner-bottom fatca-bottom-content">
                        <FormControl error={!!errors.isChecked}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="fatca-acknowledge"
                                        checked={isChecked}
                                        onChange={() => setChecked(!isChecked)}
                                        onFocus={() => {
                                            const { isChecked, ...rest } = errors;
                                            setErrors(rest);
                                        }}
                                        disabled={loading}
                                    />
                                }
                                label={<>{dashboard.FatcaDeclaration.acknowledge} </>}
                            />
                            <FormHelperText>{errors.isChecked}</FormHelperText>
                        </FormControl>
                        <Button onClick={handleSubmit} className="customBtn" disabled={loading}>
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, newPurchase }: RootStateType) => ({ ...authReducer, ...newPurchase }),
    {
        sendPhoneOTP,
        getCountries,
        getFatcaDetails,
    },
)((props: any) => LoadProfileRoutes(props, FatcaDeclaration));
